import { createContext } from "react";
import type { Dispatch, SetStateAction } from "react";

/** Valor del contexto de autenticación/sesión. */
export interface AuthContextValue {
  usuarioAutenticado: any;
  setUsuarioAutenticado: Dispatch<SetStateAction<any>>;
  authLogout: () => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
